import PropTypes from 'prop-types';
import React from 'react';
import './ModalHeader.css';

class ModalHeader extends React.Component {
  render() {
    return <div className="ModalHeader">{this.props.children}</div>;
  }
}

ModalHeader.propTypes = {
  children: PropTypes.node,
};

export default ModalHeader;
